import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/FileUploader' /* webpackChunkName: "FileUploader" */),
    import(
      './viewer/FileUploader.controller' /* webpackChunkName: "FileUploader" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('FileUploader', UiTypes),
};

export default entry;
